import { useEffect, useState } from 'react';
export const useDidUpdateEffect = (fn, inputs) => {
  const [isMounted, setIsMounted] = useState(false);

  // oxlint-disable-next-line eslint-plugin-react/exhaustive-deps
  useEffect(() => {
    if (isMounted) {
      fn();
    } else {
      setIsMounted(true);
    }
    // oxlint-disable-next-line eslint-plugin-react/exhaustive-deps
  }, inputs);
};
//# sourceMappingURL=useDidUpdateEffect.js.map